import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { MinusIcon } from "../../../@lib/icons/minus";
import { PlusIcon } from "../../../@lib/icons/plus";
import { Trans } from "react-i18next";
import { Link } from "react-router-dom";

function FAQ({ translator, onClickHandler }: any) {
  const [isExpanded, setIsExpanded] = useState({ status: false, index: null });

  const handleAccordionChange = (event: any, expanded: any, index: any) => {
    setIsExpanded({ status: expanded, index: index });
  };
  return (
    <>
      <Accordion
        expanded={isExpanded?.status && isExpanded?.index === 1}
        onChange={(event, expanded) =>
          handleAccordionChange(event, expanded, 1)
        }
        sx={{ width: "100%" }}
      >
        <AccordionSummary
          expandIcon={
            <Box>
              {isExpanded?.status && isExpanded?.index === 1 ? (
                <MinusIcon />
              ) : (
                <PlusIcon />
              )}
            </Box>
          }
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography fontWeight={"700"}>
            {translator("landingPage.What is The Niyel Tracker?")}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            {translator(
              "landingPage.The Niyel Tracker is the first African tracking tool to support your advocacy and decision-making with precise, real-time data. It is your go-to resource for staying informed and adapting to the ever-evolving landscape of policies and practices across Africa."
            )}
          </Typography>
          <Typography fontSize={"16px"} mt={2}>
            {translator("support.If this article is not helpful? Please")}{" "}
            <Button
              style={{
                color: "#F6A000",
                fontWeight: "600",
                textDecoration: "none",
              }}
              onClick={onClickHandler}
            >
              {translator("support.Contact Us")}!
            </Button>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={isExpanded?.status && isExpanded?.index === 2}
        onChange={(event, expanded) =>
          handleAccordionChange(event, expanded, 2)
        }
        sx={{ width: "100%" }}
      >
        <AccordionSummary
          expandIcon={
            <Box>
              {isExpanded?.status && isExpanded?.index === 2 ? (
                <MinusIcon />
              ) : (
                <PlusIcon />
              )}
            </Box>
          }
          aria-controls="panel2-content"
          id="panel2-header"
        >
          <Typography fontWeight={"700"}>
            {translator(
              "landingPage.What issue areas does the Niyel Tracker currently cover?"
            )}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            {translator(
              "landingPage.The Niyel Tracker will initially focus on three key areas"
            )}
          </Typography>
          <ul>
            <li>
              <span style={{ fontWeight: "700" }}>
                {translator("landingPage.Sanitation")}
              </span>{" "}
              {translator("landingPage.in Senegal, Burkina Faso, and Uganda.")}
            </li>
            <li>
              <span style={{ fontWeight: "700" }}>
                {translator("landingPage.Health & Immunization")}
              </span>{" "}
              {translator("landingPage.in Nigeria and the DRC.")}
            </li>
            <li>
              <span style={{ fontWeight: "700" }}>
                {translator("landingPage.Data Governance and AI")}
              </span>{" "}
              {translator(
                "landingPage.in Benin, Burkina Faso, and Senegal. We plan to expand our coverage to include all SDGs and the entire continent."
              )}
            </li>
          </ul>
          <Typography fontSize={"16px"} mt={2}>
            {translator("support.If this article is not helpful? Please")}{" "}
            <Button
              style={{
                color: "#F6A000",
                fontWeight: "600",
                textDecoration: "none",
              }}
              onClick={onClickHandler}
            >
              {translator("support.Contact Us")}!
            </Button>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={isExpanded?.status && isExpanded?.index === 6}
        onChange={(event, expanded) =>
          handleAccordionChange(event, expanded, 6)
        }
        sx={{ width: "100%" }}
      >
        <AccordionSummary
          expandIcon={
            <Box>
              {isExpanded?.status && isExpanded?.index === 6 ? (
                <MinusIcon />
              ) : (
                <PlusIcon />
              )}
            </Box>
          }
          aria-controls="panel1-content"
          id="panel3-header"
        >
          <Typography fontWeight={"700"}>
            {" "}
            {translator(
              "landingPage.How is the Niyel Tracker developed and kept up to date?"
            )}{" "}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            <Trans i18nKey={"landingPage.fifthFAQDescription"} />
            {/* {translator(
                    "landingPage.The Niyel Tracker is powered by a team of student interns who are the primary researchers, mining data and keeping our information current. This initiative is as much about building capacity as it is about gathering data: we provide training and introduce students to the workforce, preparing them for future careers. Additionally, we have partnered with an African AI firm to lead the development of the Tracker. We believe in leveraging local talent and ensuring all data is stored and used on the continent, reinforcing our commitment to African innovation."
                  )} */}
          </Typography>
          <Typography fontSize={"16px"} mt={2}>
          {translator("support.If this article is not helpful? Please")}{" "}
            <Button
              style={{
                color: "#F6A000",
                fontWeight: "600",
                textDecoration: "none",
              }}
              onClick={onClickHandler}
            >
              {translator("support.Contact Us")}!
            </Button>
          </Typography>
        </AccordionDetails>
      </Accordion>
      <Accordion
        expanded={isExpanded?.status && isExpanded?.index === 3}
        onChange={(event, expanded) =>
          handleAccordionChange(event, expanded, 3)
        }
        sx={{ width: "100%" }}
      >
        <AccordionSummary
          expandIcon={
            <Box>
              {isExpanded?.status && isExpanded?.index === 3 ? (
                <MinusIcon />
              ) : (
                <PlusIcon />
              )}
            </Box>
          }
          aria-controls="panel1-content"
          id="panel4-header"
        >
          <Typography fontWeight={"700"}>
            {translator(
              "landingPage.Who can benefit from using the Niyel Tracker?"
            )}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography>
            {translator("landingPage.Our platform is designed for")}
            <ul>
              <li>
                <span style={{ fontWeight: "700" }}>
                  {translator("landingPage.Civil Society Organizations (CSOs)")}
                </span>{" "}
                {translator(
                  "landingPage.To gain insights that strengthen their impact and strategies."
                )}
              </li>
              <li>
                <span style={{ fontWeight: "700" }}>
                  {translator("landingPage.Advocates and Activists")}
                </span>{" "}
                {translator(
                  "landingPage.To stay updated and effectively mobilize for change."
                )}
              </li>
              <li>
                <span style={{ fontWeight: "700" }}>
                  {translator("landingPage.Governments and Policymakers")}
                </span>{" "}
                {translator(
                  "landingPage.To collaborate more efficiently and maintain accountability."
                )}
              </li>
              <li>
                <span style={{ fontWeight: "700" }}>
                  {translator("landingPage.Foundations and Funders")}
                </span>{" "}
                {translator(
                  "landingPage.To make informed decisions about where to allocate resources."
                )}
              </li>
            </ul>
          </Typography>
          <Typography fontSize={"16px"} mt={2}>
            {translator("support.If this article is not helpful? Please")}{" "}
            <Button
              style={{
                color: "#F6A000",
                fontWeight: "600",
                textDecoration: "none",
              }}
              onClick={onClickHandler}
            >
              {translator("support.Contact Us")}!
            </Button>
          </Typography>
        </AccordionDetails>
      </Accordion>
    </>
  );
}

export { FAQ };
